<template>
    <div class="maskbg">
        <div class="dialog jsln">
            <div class="close" @click="handleClose"></div>
            <div class="main">
                <swiper :options="swiperOption" ref="mySwiper" class="swiper"  v-if="images.length>1">
                    <!-- slides -->
                    <swiper-slide v-for="(item, index) in images" :key="index">
                        <img :src="item.url">
                    </swiper-slide>
                    <!-- Optional controls -->
                    <div class="swiper-pagination" slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
                <img :src="images[0].url" v-else>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
    components: {swiper, swiperSlide},
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        images: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            swiperOption: {
                loop: true,
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                // 显示分页
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true //允许分页点击跳转
                },
                // 设置点击箭头
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                }
            },
        }
    },
    created() {
    },
    methods: {
        handleClose(){
            this.$emit('update:visible', false)
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/common';
@import '@/styles/dialog';
</style>